/* ── INVASIVE THOT CUSTOM ─────────────────────────────────────
   Opens the notify-me dialog (snippets/it-notify-modal.liquid)
   when a card's NOTIFY bar is clicked, tags the signup with
   the product's handle, and shows the success toast after the
   form round-trips back with ?it_notified=1.
   ───────────────────────────────────────────────────────────── */

(() => {
  const modal = document.getElementById('it-notify-modal');

  if (modal) {
    document.addEventListener('click', (e) => {
      const bar = e.target.closest('.it-notify-bar');
      if (bar) {
        e.preventDefault();
        const tags = modal.querySelector('[data-it-tags]');
        if (tags) tags.value = 'notify-me,notify-' + (bar.dataset.itHandle || 'unknown');
        const title = modal.querySelector('[data-it-product-title]');
        if (title) title.textContent = bar.dataset.itTitle || '';
        modal.showModal();
        return;
      }
      if (e.target.closest('[data-it-close]')) modal.close();
      /* click on the backdrop (outside the inner panel) closes */
      if (e.target === modal) modal.close();
    });
  }

  /* back from Shopify with a successful signup: toast it */
  const url = new URL(location.href);
  if (url.searchParams.has('it_notified') || url.searchParams.has('customer_posted')) {
    const toast = document.getElementById('it-toast');
    if (toast) {
      toast.hidden = false;
      setTimeout(() => {
        toast.hidden = true;
      }, 4500);
    }
    url.searchParams.delete('it_notified');
    url.searchParams.delete('customer_posted');
    history.replaceState({}, '', url.pathname + url.search);
  }
})();
